export const cdnUploadsBaseUrl = "//cdnimg.webstaurantstore.com/uploads";

export const modifiedPlusImageLink = `${cdnUploadsBaseUrl}/design/2024/12/plus_badge_variations.svg`;

export const plusLogoLink = `${cdnUploadsBaseUrl}/design/2023/7/pluslogo.svg`;
